export const LoginTypes = [
  {id: 1, name: "PHONE_LOGIN"},
  {id: 2, name: "EMAIL_LOGIN"},
  {id: 3, name: "GMAIL_LOGIN"},
  {id: 4, name: "APPLE_LOGIN"},
];